import protectedComponent from 'components/helpers/protectedComponent';
import action from 'common/rbac/actions';

export default protectedComponent(() => import('./CreateOrganization'), {
  action: action.ORGANIZATION_CREATE,
});
